var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Cron Notification Email ")]),
              _c(
                "gg-card-text",
                [
                  _c("p", [
                    _vm._v(
                      " Send an email with the output every time the cron job runs. You can have cron send an email every time it runs a command which produces output. If you do not want an email to be sent for an individual cron job, you can redirect the command’s output to /dev/null. For example: "
                    ),
                    _c("code", [_vm._v("mycommand >/dev/null 2>&1")])
                  ]),
                  !_vm.isLoadingEmail && _vm.accountUser
                    ? _c("cron-email-form", {
                        attrs: {
                          "account-user": _vm.accountUser
                        }
                      })
                    : _c("v-progress-linear", {
                        attrs: {
                          indeterminate: "",
                          color: "green",
                          height: "4"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Add New Cron Job ")]),
              _c(
                "gg-card-text",
                [
                  _c("p", [_vm._v("PHP command examples:")]),
                  _c("p", [
                    _vm._v(" General example: "),
                    _c("code", [
                      _vm._v(
                        "/usr/local/bin/php /home/" +
                          _vm._s(_vm.accountUser) +
                          "/public_html/path/to/cron/script"
                      )
                    ])
                  ]),
                  _c("cron-job-form", {
                    on: {
                      "job-added": _vm.reloadTable
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Manage Cron Jobs ")]),
              _c(
                "gg-card-text",
                [
                  _c("cron-jobs-table", {
                    attrs: {
                      "table-should-be-reloaded": _vm.tableShouldBeReloaded
                    },
                    on: {
                      "table-reloaded": _vm.tableReloaded
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }